<template>
  <div class="text-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <cx-slider v-if="pageType === 'detailPage'" :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
        <div v-else class="audio-source-box">
          <cx-slider :value.sync="audioAddress" :options="dataSourceOptions" :height="32" />
          <div v-if="audioAddress == '本地上传'" class="mt16">
            <el-upload
              name="uploadFile"
              action="/engine2/usts"
              accept=".mp3,.wma"
              :on-preview="handleMusicPreview"
              :on-success="handleMusicSuccess"
              :on-error="handleMusicfail"
              :show-file-list="false"
              v-show="!musicSrc"
            >
              <el-button v-if="!musicSrc" class="upload-btn mb8"> <span class="icon-plus"></span> 上传音频 </el-button>
            </el-upload>
            <div class="content-item card mb8" v-show="musicSrc">
              <p class="music-name">{{ musicName }}</p>
              <div class="verticallyTop height24">
                <el-upload
                  name="uploadFile"
                  action="/engine2/usts"
                  accept=".mp3,.wma"
                  :on-preview="handleMusicPreview"
                  :on-success="handleMusicSuccess"
                  :on-error="handleMusicfail"
                  :show-file-list="false"
                >
                  <span class="handle-icon-box mr4" @mousedown.stop
                    ><i class="icon icon-portal-edit-1"></i><span class="icon-tips">重新上传</span></span
                  >
                </el-upload>
                <span class="handle-icon-box" @mousedown.stop @click="handleMusicDel"
                  ><i class="icon icon-portal-delete1"></i><span class="icon-tips">删除</span>
                </span>
              </div>
            </div>
            <p class="tips">支持MP3、WMA格式，大小不超过600M</p>
          </div>
          <div v-else-if="!showColsFieldMapping" class="music-input mt16">
            <el-input v-model="musicSrc" placeholder="音频链接地址"></el-input>
            <i class="icon-portal-close-one" v-show="musicSrc" @click="handleMusicDel"></i>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="(showColsFieldMapping && audioAddress === '音频地址') || (pageType === 'detailPage' && noCacheComponent)"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="数据绑定"
        name="2"
      >
        <div v-if="showColsFieldMapping && audioAddress === '音频地址'" class="content">
          <colsFieldMappingSetting :ids="dataIds" :myId="ids" :options="options"></colsFieldMappingSetting>
        </div>
        <detailPageFieldMappingSetting v-else :myid="ids" :options="options"></detailPageFieldMappingSetting>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import { isExist } from "utils/index"
import dataToolMixin from "materials/dataToolMixin"

export default {
  name: "audio-options-data",
  components: {detailPageFieldMappingSetting, colsFieldMappingSetting},
  mixins: [dataToolMixin],
  props: { options: Object },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2", "3"],
      collapseActiveNames: []
    }
  },
  computed: {
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
        if (this.pageType === "detailPage" && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataKey",
              fieldFlag: ""
            },
            "detailFieldMapping",
            false
          )
        }
      }
    },
    audioAddress: {
      get() { 
        // return this.checkAndSetPrimaryVal(this.options, "audioAddress", "audioAddress", "本地上传")
        return this.options.hasOwnProperty("audioAddress") ? this.options.audioAddress : "本地上传"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "audioAddress", false)
      }
    },
    musicSrc: {
      get() {
        return this.options.audioUrl ? this.options.audioUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "audioUrl", false)
      }
    },
    musicName: {
      get() {
        return this.options.audioName ? this.options.audioName : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "audioName", false)
      }
    },
    showColsFieldMapping() {
      return this.dataIds?.uid || isExist(this.dataIds?.elementInSwiperId) || this.dataIds?.elementInDataGridId
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }, { value: true, title: "数据绑定" }]
      return options
    },
    dataSourceOptions() {
      const options = [{ value: "本地上传", title: "本地数据" }]
      if(this.showColsFieldMapping) {
        options.push({ value: "音频地址", title: "数据绑定" })
      } else {
        options.push({ value: "音频地址", title: "音频地址" })
      }
      return options
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    handleMusicPreview(file) {
      // console.log(file)
    },
    handleMusicSuccess(response, file, fileList) {
      console.log(response)
      let size = Number(file.size / 1024 / 1024)
      if (size > 600) return
      this.musicSrc = response.data.url
      this.musicName = response.data.name
      this.$changeOptionsEV("", "objectId", false)
    },
    handleMusicfail(err, file, fileList) {
      // console.log(err)
    },
    handleMusicDel() {
      this.musicSrc = ""
      this.musicName = ""
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-btn {
  width: 98px;
  line-height: 28px;
  box-sizing: border-box;
  padding: 0;
  text-align: center;
}

.upload-btn span {
  margin-right: 4px;
}

.music-upload-box {
  position: fixed;
  width: 336px;
  left: 584px;
  top: 80px;
  z-index: 10;
  background-color: #fff;
}

::v-deep .music-upload-box {
  .el-message-box__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }

  .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }

  .el-tabs__nav-scroll {
    padding: 0;
  }

  .el-tabs__item {
    font-size: 14px;
    color: var(--text);
    margin-top: 0;
    line-height: 40px;
    padding: 0 8px;

    &.is-active {
      color: var(--themeColor);
    }
  }

  .el-tabs__header {
    //background-color: #fff;
    width: 100%;
  }

  p {
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.4);
  }
}

.audio-source-box {
  position: relative;

  .height24 {
    height: 24px;
  }

  .tips {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.4);
  }

  .music-name {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    line-height: 20px;
  }

  .card {
    padding: 8px;
  }

  .music-input {
    position: relative;
  }

  .icon-portal-close-one {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 34px;
    height: 32px;
    line-height: 32px;
    display: inline-block;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
    cursor: pointer;
  }
}

.handle-icon-box {
  position: relative;
  width: 24px;
  height: 24px;
  display: block;

  &:hover {
    .icon {
      background: rgba(0, 0, 0, 0.06);
    }

    .icon-tips {
      display: block;
    }
  }

  .icon {
    display: inline-block;
    text-align: center;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.4);
    font-size: 14px;
    cursor: pointer;
  }

  .icon-tips {
    position: absolute;
    display: none;
    background: rgba(0, 13, 34, 0.9);
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 14px;
    top: -44px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.8);
    z-index: 2;
    line-height: 20px;
    box-sizing: border-box;
    word-break: keep-all;

    &:after {
      position: absolute;
      content: "";
      bottom: -10px;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-color: rgba(0, 13, 34, 0.9) transparent transparent;
      border-style: solid;
      z-index: 2;
    }
  }
}

::v-deep .music-input input {
  padding-right: 34px;
}
</style>
